import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Button } from '../ui/button';
import Cart from '../Cart/Cart';
import CarModelsDropdown from './CarModelsDropdown';

const PageHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleCustomizeClick = () => {
    navigate('/customize');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-14 items-center gap-6">
        {/* Logo/Home */}
        <a href="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          <img src="/images/logo.svg" alt="Dekalio" className="h-6 w-6" />
          <span className="font-semibold">Dekalio</span>
        </a>
        
        {/* Main Navigation */}
        <nav className="hidden md:flex items-center justify-center gap-1 flex-1">
          <CarModelsDropdown />
          <Button 
            variant="ghost" 
            size="sm"
            onClick={() => navigate('/faq')}
            className={`text-sm font-medium ${isActive('/faq') ? 'bg-accent' : ''}`}
          >
            FAQ
          </Button>
          <Button 
            variant="ghost" 
            size="sm"
            onClick={() => navigate('/support')}
            className={`text-sm font-medium ${isActive('/support') ? 'bg-accent' : ''}`}
          >
            Support
          </Button>
          <Button 
            variant="ghost" 
            size="sm"
            onClick={() => navigate('/om-oss')}
            className={`text-sm font-medium ${isActive('/om-oss') ? 'bg-accent' : ''}`}
          >
            Om oss
          </Button>
          <Button 
            variant="ghost" 
            size="sm"
            onClick={() => navigate('/kontakt')}
            className={`text-sm font-medium ${isActive('/kontakt') ? 'bg-accent' : ''}`}
          >
            Kontakt
          </Button>
        </nav>

        {/* Right Side Actions */}
        <div className="flex items-center gap-2 ml-auto">
          <Cart />
          <Button size="sm" variant="default" onClick={handleCustomizeClick}>
            Börja designa
          </Button>
        </div>

        {/* Mobile Menu */}
        <Button variant="ghost" size="icon" className="md:hidden ml-auto">
          <Menu className="h-5 w-5" />
        </Button>
      </div>
    </nav>
  );
};

export default PageHeader;

